/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './ZendeskTicketRendererStyles.scss';
const baseClass = 'qmb-ui-ZendeskTicketRenderer';
/**
 * ZendeskTicketRenderer
 *
 * Confirms a support ticket was created: ticket number, subject, and copy telling the
 * customer they have been emailed and can reply there.
 *
 * **There is no link, and no-link is the primary state — not a fallback.** This is
 * deliberate (Ken, 2026-07-30), and the reasoning is recorded here so nobody "fixes"
 * it later by adding a link that cannot work:
 *
 * - A raw `hc/requests/{id}` URL requires the visitor to be signed into Zendesk's own
 *   help-centre auth, which our customers have never done. Making it work would need
 *   Zendesk JWT SSO plus a per-click token-minting redirect endpoint.
 * - The incumbent experience has no portal destination either — Fin hands off into
 *   Intercom's inbox and the customer keeps talking in the same widget.
 * - R4 already chose email as the continuation channel, and Zendesk notifies the
 *   requester on creation and on every agent reply by default.
 *
 * So the copy reads as a confident, normal outcome. It must **not** say anything like
 * "a direct link isn't available right now", which frames a deliberate design as a
 * degradation. `ticket_url` is carried in the block type but there is no branch on it
 * here — a link-present path is future scope, not something half-built now.
 *
 * @version 1.0.0
 * @since 2026-07-30
 */
export function ZendeskTicketRenderer({ block }) {
    const ticket = block;
    const continuationCopy = `We've emailed you a copy of ticket #${ticket.ticket_number}. Reply to that email and our support team will pick it up from there.`;
    const sections = [
        {
            label: `Ticket #${ticket.ticket_number}`,
            content: (React.createElement("div", { className: baseClass },
                React.createElement(Text, { variant: "x-small", as: "h4", className: `${baseClass}__subject` }, ticket.title),
                React.createElement(Text, { variant: "body", className: `${baseClass}__description` }, ticket.short_description),
                React.createElement(Text, { variant: "body", className: `${baseClass}__continuation` }, continuationCopy))),
            copyText: `Ticket #${ticket.ticket_number} — ${ticket.title}\n${ticket.short_description}`
        }
    ];
    return React.createElement(AIGeneralBlockCard, { sections: sections });
}
